import installation_services_card1 from '@/app/[locale]/common/assets/images/services/installation-services/products/fuel-level-sensor.webp';
import installation_services_card2 from '@/app/[locale]/common/assets/images/services/installation-services/products/fuel-flowmeters.webp';
import installation_services_card3 from '@/app/[locale]/common/assets/images/services/installation-services/products/telematic-gateway.webp';
import installation_services_card4 from '@/app/[locale]/common/assets/images/services/installation-services/products/local-displays-controllers.webp';
import installation_services_card4_mob_version from '@/app/[locale]/common/assets/images/services/installation-services/products/local-displays-controllers-mob-version.webp';

import {APP_ROUTES} from "../app";
import services_installation from '../../assets/images/services/installation.webp';
import services_monitoring from '../../assets/images/services/monitoring.webp';
import services_warranty_afterSales from '../../assets/images/services/warranty-after-sales.webp';

export const SERVICES_PAGE_LABELS = {
    OUR_SERVICES: 'Our Services',
    INSTALLATION_SERVICES: 'Installation Services',
    CHOOSE: 'Why Choose Us?',
    INDUSTRIES: 'Industries We Serve',
    PRODUCTS: 'What We Do?',
    MATTERS: 'Why It Matters?',
    CONTACT: 'Ready to Get Started?',
    EXPECT: 'What to Expect from Us?',
};

export const MONITORING_SERVICES_PAGE_LABELS = {
    MONITORING_SERVICES: 'Monitoring Services',
    ONLINE_MONITORING: 'Online Monitoring Services',
    FUEL_MONITORING: 'Fuel Monitoring Services',
    KEY_FEATURE: 'Key Feature Of Platform',
    SUBSCRIPTION: 'Subscription Services',
    INDUSTRIES: 'Industries We Support',
    CONTACT: 'Take Control of Your Operations',
    CHOOSE: 'Why Choose EDJR Monitoring Services?',
};

export const WARRANTY_SERVICES_PAGE_LABELS = {
    WARRANTY_SERVICES: 'Warranty and After-Sales Services',
    WHY_CHOOSE: 'Why Choose EDJR?',
    OUR_SERVICES: 'Our Warranty Services',
    CONTACT: 'Contact Us Today',
    BENEFITS: 'Benefits of Choosing EDJR',
    OUR_PROCESS: 'Our Process',
};

export const SERVICES_PAGE_BREAD_CRUMB_CONTENT = {
    SERVICES: {title: 'Services', href: APP_ROUTES.SERVICES},
    INSTALLATION_SERVICES: {title: 'Installation Services', href: `${APP_ROUTES.SERVICES}/installation-services`},
    MONITORING_SERVICES: {title: 'Monitoring Services', href: `${APP_ROUTES.SERVICES}/monitoring-services`},
    WARRANTY_SERVICES: {title: 'Warranty Services', href: `${APP_ROUTES.SERVICES}/warranty-services`},
};

export const SERVICES_PAGE_CARDS_CONTENT = [
    {
        label: 'Installation Services',
        image: services_installation,
        href: `${APP_ROUTES.SERVICES}/installation-services`,
    },
    {
        label: 'Monitoring Services',
        image: services_monitoring,
        href: `${APP_ROUTES.SERVICES}/monitoring-services`,
    },
    {
        label: 'Warranty and After-Sales Services',
        image: services_warranty_afterSales,
        href: `${APP_ROUTES.SERVICES}/warranty-services`,
    },
];

export const INSTALLATION_SERVICES_PAGE_TOP_BLOCK_CONTENT = [
    'At EDJR, we believe that the right installation makes all the difference. That’s why we offer expert telematics installation services tailored to your unique needs.',
    'Whether you manage a fleet, operate heavy equipment, or oversee complex machinery, we’re here to ensure your systems work flawlessly from day one.',
];

export const INSTALLATION_SERVICES_PAGE_EXPECT_CARDS_CONTENT = [
    {
        label: 'Initial Consultation',
        text: 'Let’s discuss your goals and the best solutions for your needs.',
    },
    {
        label: 'On-Site Installation',
        text: 'Our experts come to you, ensuring everything fits perfectly.',
    },
    {
        label: 'Thorough Testing',
        text: 'We leave nothing to chance, ensuring your system is fully operational.',
    },
    {
        label: 'Post-Installation Support:',
        text: 'Have questions? Need adjustments? We’re just a call away.',
    },
];

export const INSTALLATION_SERVICES_PAGE_MATTERS_CARDS_CONTENT = [
    {
        label: 'Accurate Data',
        text: 'Reliable readings from every sensor and meter.',
    },
    {
        label: 'Streamlined Operations',
        text: 'Integration that works seamlessly with your existing setup.',
    },
    {
        label: 'Cost Savings',
        text: 'Avoid errors and downtime that come from poor installation.',
    },
];

export const INSTALLATION_SERVICES_PAGE_PRODUCTS_CARDS_CONTENT = [
    {
        label: 'Fuel level sensors',
        text: 'Keep track of every drop of fuel, cut costs, and eliminate wastage.',
        image: installation_services_card1,
        href: '/products/fuel-level-sensors',
    },
    {
        label: 'Fuel flow meters',
        text: 'Gain actionable insights into fuel usage to maximize efficiency.',
        image: installation_services_card2,
        href: '/products/fuel-flow-meters',
    },
    {
        label: 'Telematic gateway',
        text: 'Connect your equipment to the cloud for real-time updates.',
        image: installation_services_card3,
        href: '/products/telematic-gateway',
    },
    {
        label: 'Local Displays and Controllers',
        text: 'Simplify operations with intuitive control systems and real-time monitoring tools.',
        image: installation_services_card4,
        imageMob: installation_services_card4_mob_version,
        href: '/products/accessories',
    },
];

export const INSTALLATION_SERVICES_PAGE_TEXTS = {
    EXPECT: 'We make the installation process simple and hassle-free:',
    INDUSTRIES: 'We provide installation services across a range of industries, tailoring our solutions to meet specific operational needs:',
    PRODUCTS: 'From fuel efficiency to equipment monitoring, our installations empower your business. Here’s how we can help:',
    MATTERS: 'Getting your telematics system installed correctly is the first step to unlocking its full potential. With a professionally installed system, you’ll benefit from:',
    CONTACT: 'Let us handle the installation while you focus on what matters most — running your business.',
};

export const MONITORING_SERVICES_PAGE_TEXTS = {
    ONLINE_MONITORING: [
        'The EDJR online monitoring platform provides a comprehensive solution to oversee the operation of your equipment remotely. ',
        'Accessible from any computer or smartphone, the platform delivers real-time data and analytics that help you make informed decisions and optimize your operations.',
    ],
    FUEL_MONITORING: 'Fuel management is at the heart of efficient operations. With EDJR’s advanced monitoring systems, you can gain precise insights into every aspect of fuel usage across your equipment. Our platform allows you to:',
    SUBSCRIPTION: 'EDJR offers flexible subscription plans tailored to your operational needs. With our subscription, you gain:',
    INDUSTRIES: 'Our monitoring services cater to a variety of industries',
};

export const INSTALLATION_SERVICES_PAGE_CARDS = {
    FUEL_MONITORING: [
        {
            label: 'Monitor Fuel Fillings',
            text: 'Track and verify every refueling event to prevent discrepancies.',
        },
        {
            label: 'Detect Fuel Drains',
            text: 'Get instant alerts for unauthorized fuel drains or leaks.',
        },
        {
            label: 'Identify Fuel Theft',
            text: 'Protect your assets with real-time monitoring of suspicious activities.',
        },
        {
            label: 'Analyze Actual Fuel Consumption',
            text: 'Understand the precise fuel usage for each unit of equipment, helping you optimize performance and reduce costs.',
        },
    ],
    KEY_FEATURE: [
        {
            label: 'Real-Time Data',
            text: 'Get instant updates on fuel levels, consumption rates, and equipment status.',
        },
        {
            label: 'Customizable Alerts',
            text: 'Receive notifications for unusual activities like excessive consumption or fuel theft.',
        },
        {
            label: 'Detailed Reports',
            text: 'View trends and analytics to identify inefficiencies and areas for improvement.',
        },
        {
            label: 'User-Friendly Interface',
            text: 'Navigate easily and access critical data anytime, anywhere.',
        },
    ],
    SUBSCRIPTION: [
        {
            label: '24/7 Access',
            text: 'Monitor your equipment anytime and anywhere.',
        },
        {
            label: 'Data Security',
            text: 'Robust encryption ensures your information is protected.',
        },
        {
            label: 'Ongoing Updates',
            text: 'Enjoy the latest improvements to our regularly updated platform.',
        },
        {
            label: 'Dedicated Support',
            text: 'Our team is always available to assist with technical support and guidance.',
        },
    ],
    WHY_CHOOSE_US: [
        {
            label: 'Advanced Fuel Monitoring',
            text: 'Gain unparalleled visibility into fuel usage, refueling, and theft detection.',
        },
        {
            label: 'Comprehensive Insights',
            text: 'Full operational visibility with detailed monitoring and analytics.',
        },
        {
            label: 'Cost Savings',
            text: 'Identify inefficiencies, reduce fuel consumption, and enhance resource allocation.',
        },
        {
            label: 'Proactive Management:',
            text: 'Address potential issues before they escalate with customizable alerts.',
        },
        {
            label: 'Flexibility',
            text: 'Manage operations from anywhere, ensuring uninterrupted business continuity.',
        },
    ],
};

export const WARRANTY_SERVICES_PAGE_CARDS = {
    WHY_CHOOSE: [
        {
            label: 'Official Technoton Dealer',
            text: 'As an authorized dealer, we provide genuine products and adhere to Technoton\'s high standards of service and support.',
        },
        {
            label: 'Certified Service Center',
            text: 'Our team is trained and certified to repair, maintain, and service Technoton equipment, ensuring your systems are in the best hands.',
        },
        {
            label: 'Comprehensive Support',
            text: 'From warranty claims to routine maintenance, we’re here to assist at every step of your equipment’s lifecycle.',
        },
    ],
    OUR_SERVICES: [
        {
            label: 'Repairs by Certified Experts',
            text: 'If your equipment is damaged or not operating correctly, our certified technicians will diagnose and repair it to restore optimal functionality.',
        },
        {
            label: 'After-Sales Support',
            text: 'Beyond warranty coverage, we offer ongoing maintenance, troubleshooting, and technical support to keep your systems performing at their best.',
        },
        {
            label: 'Genuine Parts and Standards',
            text: 'We use only authentic Technoton parts and follow official service guidelines to ensure the highest quality repairs.',
        },
        {
            label: 'Warranty Coverage',
            text: 'We honor warranty claims for Technoton equipment, providing hassle-free replacements or repairs as required.',
        },
    ],
    BENEFITS: [
        {
            label: 'Reliability',
            text: 'As an official service standard, we ensure your equipment is in the best possible condition.',
        },
        {
            label: 'Expertise',
            text: 'Our technicians are certified and experienced in handling even the most complex repairs.',
        },
        {
            label: 'Peace of Mind',
            text: 'Genuine parts, adherence to warranty standards, and excellent after-sales support ',
        },
        {
            label: 'Minimized Downtime',
            text: 'Our efficient repair and service process helps you get back to business quickly.',
        },
    ],
    PROCESS: [
        {
            label: "Inspection and Diagnosis",
            description:
                "Bring your equipment to our certified service center, or schedule an on-site inspection. Our experts will identify the issue promptly.",
            hasArrow: true,
        },
        {
            label: "Warranty Validation",
            description:
                "If the issue is covered under warranty, we handle the claim process for you.",
            hasArrow: false,
        },
        {
            label: "Repair or Replacement",
            description:
                "Whether it’s a minor repair or a full replacement, we ensure swift and efficient resolution.",
            hasArrow: true,
        },
        {
            label: "Testing and Quality Assurance",
            description:
                "We thoroughly test the equipment to confirm it meets operational standards before returning it to you.",
            hasArrow: false,
        },
        {
            label: "Post-Service Support",
            description:
                "Have questions or need follow-up support? Our team is always ready to assist.",
            hasArrow: false,
        },
    ],
};

export const WARRANTY_SERVICES_PAGE_TEXTS = {
    CONTACT: 'When it comes to warranty and after-sales services, EDJR is the name you can trust. Whether you need a repair, replacement, or routine support, we’re here to help.',
    BENEFITS: 'When you choose EDJR, you gain access to warranty services designed to keep your operations running smoothly:',
};
